<template>
  <div class="data-wrapper" >
   <div class="list-loading" v-if="!dataDone"><van-loading type="spinner" size="14px">正在加载中...</van-loading></div>
     <div class="doctor-list" v-else-if="dataDone && dataList.length > 0">
       <div class="doctor-item" v-for="item in dataList">
         <div class="doctor-card">
           <div class="doc-info">
             <div class="info">
               <div class="avatar"><img :src="item.doc_avatar" alt=""></div>
               <div class="info-text">
                 <div class="name">{{item.doc_name}}</div>
                 <div class="title">{{item.title | jobTitleFilter}}</div>
                 <div class="department"><span>{{item.work_unit}}</span></div>
               </div>
             </div>
             <div class="price-box">
               <div class="price">过期时间</div>
               <div class="price-type">{{item.expire_time | ExpDateFilter}}</div>
             </div>
           </div>
           <!--
           <div class="card-control">
             <div class="last-time">
               <div class="type">过期时间</div>
               <div class="date">{{item.expire_time | ExpDateFilter}}</div>
             </div>

           </div>
           -->
         </div>

       </div>

     </div>
        <div class="empty-record" v-else>
          <icon icon-class="empty-template"></icon>
          <p class="text">暂无诊疗券可用</p>
        </div>
   </div>

  </div>
</template>

<style lang="less" scoped>
.data-wrapper{
    position: relative;
    .empty-record{
      border-top: 6px solid #F7F7F7;
      padding-top: 32px;
      text-align: center;
      font-size: 15px;
      line-height: 15px;
      svg{
        position: relative;
        left: -3px;
        font-size: 72px;
      }
      .text{
        margin-top: 12px;
        font-size: 15px;
        line-height: 15px;
        color: #CCC;
      }
    }
    .doctor-list{
      padding: 16px;
      min-height: 100vh;
      background: #F7F7F7;
      .doctor-item{
        margin-bottom: 12px;
        .doctor-card{
          position: relative;
          background: #FFF;
          padding: 0 16px;
          border-radius: 6px;
          box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
          z-index: 11;
          .doc-info{
            position: relative;
            padding: 12px 0 10px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: 1px solid #EEE;
            .info{
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              .avatar{
                width: 56px;
                height: 56px;
                overflow: hidden;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                  width: 100%;
                }
              }
              .info-text{
                margin-left: 8px;
                margin-top: 6px;
                .name{
                  font-size: 15px;
                  line-height: 18px;
                  color: @black;
                  padding-left: 8px;
                  max-width: 90%;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  font-weight: bold;
                }
                .title{
                  margin-top: 6px;
                  color: #999;
                  font-size: 14px;
                  font-weight: normal;
                  padding-left: 8px;
                }
                .department{
                  margin-top: 8px;
                  height: 24px;
                  font-size: 14px;
                  line-height: 24px;
                  color: rgba(0, 132, 138, 0.2);
                  display: inline-flex;
                  align-items: center;
                  .xile-alpha(0.06);
                  span{
                    color: @xile;
                    margin: 0 8px;
                  }
                }
              }
            }
            .price-box{
              position: absolute;
              top: 24px;
              right: 0;
              .price{
                font-size: 15px;
                line-height: 15px;
                color: @black;
                em{
                  font-size: 12px;
                  margin-right: 2px;
                }
                span{
                  font-size: 12px;
                  margin-left: 4px;
                }
              }
              .price-type{
                margin-top: 4px;
                font-size: 13px;
                line-height: 13px;
                color: #999;
                text-align: right;
              }
            }
          }
          .card-control{
            height: 52px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .last-time{
              font-size: 13px;
              line-height: 13px;
              .type{
                color: #666;
              }
              .date{
                margin-top: 5px;
                color: #666;
              }
            }
            .check-detail{
              @button-base();
              @button-border();
              width: 76px;
              height: 29px;
              font-weight: normal;
              font-size: 13px;
              border-radius: 28px;
            }
          }
        }
        .status{
          position: relative;
          border-radius: 6px;
          background: @xile;
          color: #FFF;
          padding: 6px 17px 0;
          margin-top: -6px;
          z-index: 10;
          &.live{
            background: #F96B6F;
          }
          .status-text{
            font-size: 14px;
            line-height: 30px;
            font-weight: bold;
          }
        }
      }
      .add-doctor{
        width: 260px;
        margin: 28px auto 0;
        .add-doctor-button{
          @button-base();
          @button-border();
          width: 100%;
          height: 38px;
          background: transparent;
          svg{
            color: @xile;
            font-size: 12px;
            margin-right: 4px;
          }
        }
      }
    }
  }
</style>


<script type="text/javascript">

  export default {
    data() {
      return {
        dataDone: false,
        dataList: [],
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    components: {

    },
    created() {
      this.$root.post('/getMyCoupon', {
        pat_id: this.userInfo.user_id
      }).then(data => {
        console.log(data);
        this.dataDone = true;
        this.dataList = data.data || [];
      })
    },
    beforeDestroy() {
      document.body.className = '';
    },
    methods: {

    },
    filters: {
      ExpDateFilter(stamp) {
        return moment.unix(stamp).format('MM/DD HH:mm');
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/MyCoupon/diaCoupon.vue